<template>
  <svg
    width="404"
    height="179"
    viewBox="0 0 404 179"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="103.667"
      y="10.1667"
      width="216.667"
      height="126.667"
      rx="11.6667"
      fill="white"
      stroke="#DDDDDD"
      stroke-width="3.33333"
    />
    <path
      d="M103.667 110.167H320.333V128.5C320.333 133.102 316.602 136.833 312 136.833H112C107.398 136.833 103.667 133.102 103.667 128.5V110.167Z"
      fill="#F0F0F0"
      stroke="#DDDDDD"
      stroke-width="3.33333"
    />
    <rect
      x="193.667"
      y="136.833"
      width="46.6667"
      height="40"
      fill="#F0F0F0"
      stroke="#DDDDDD"
      stroke-width="3.33333"
    />
    <path
      d="M43.6666 165.167C43.6666 162.405 45.9052 160.167 48.6666 160.167H115.333C118.095 160.167 120.333 162.405 120.333 165.167V176.833H43.6666V165.167Z"
      fill="#F0F0F0"
      stroke="#DDDDDD"
      stroke-width="3.33333"
    />
    <path
      d="M122.433 99.7501C133.613 77.9492 125.62 27.9735 122.795 12.5764C122.334 10.0617 120.446 8.09493 117.956 7.51424C110.426 5.75807 93.9936 2.26878 82.2247 2.25008C70.3157 2.23115 53.6739 5.75084 46.0817 7.51591C43.59 8.09518 41.7016 10.0639 41.2534 12.5824C38.5119 27.9865 30.8962 77.9521 42.0747 99.7501C50.4081 116 70.1655 126.519 68.3249 143.083C67.4915 150.583 59.933 157.25 57.0164 159.75H107.016C104.1 157.25 97.0163 150.583 96.1829 143.083C94.3423 126.519 114.1 116 122.433 99.7501Z"
      fill="white"
    />
    <path
      d="M122.795 12.5764L124.434 12.2756V12.2756L122.795 12.5764ZM122.433 99.7501L123.916 100.511L122.433 99.7501ZM96.1829 143.083L97.8394 142.899L96.1829 143.083ZM107.016 159.75V161.417H111.522L108.101 158.485L107.016 159.75ZM117.956 7.51424L117.578 9.13734L117.956 7.51424ZM82.2247 2.25008L82.222 3.91674L82.2247 2.25008ZM46.0817 7.51591L45.7043 5.89254L46.0817 7.51591ZM57.0164 159.75L55.9317 158.485L52.5111 161.417H57.0164V159.75ZM41.2534 12.5824L42.8942 12.8745L41.2534 12.5824ZM42.0747 99.7501L43.5578 98.9895L42.0747 99.7501ZM68.3249 143.083L69.9813 143.267L68.3249 143.083ZM121.156 12.8772C122.563 20.5459 125.254 36.8113 126.202 53.8544C126.676 62.3761 126.712 71.0571 125.945 78.9355C125.175 86.8377 123.607 93.8094 120.95 98.9895L123.916 100.511C126.85 94.7903 128.475 87.3398 129.262 79.2588C130.052 71.1542 130.01 62.2912 129.53 53.6692C128.571 36.425 125.853 20.004 124.434 12.2756L121.156 12.8772ZM120.95 98.9895C116.902 106.883 110.136 113.298 104.226 120.216C98.4548 126.971 93.5219 134.227 94.5264 143.267L97.8394 142.899C97.0033 135.375 101.029 129.09 106.76 122.381C112.351 115.836 119.631 108.867 123.916 100.511L120.95 98.9895ZM94.5264 143.267C94.9915 147.452 97.1746 151.283 99.4965 154.307C101.835 157.352 104.431 159.729 105.932 161.015L108.101 158.485C106.685 157.271 104.281 155.064 102.14 152.277C99.983 149.467 98.2077 146.214 97.8394 142.899L94.5264 143.267ZM118.335 5.89113C110.817 4.13782 94.2113 0.602453 82.2273 0.583411L82.222 3.91674C93.776 3.9351 110.035 7.37832 117.578 9.13734L118.335 5.89113ZM82.2273 0.583411C70.1009 0.564144 53.2839 4.1304 45.7043 5.89254L46.4591 9.13929C54.0639 7.37129 70.5304 3.89816 82.222 3.91674L82.2273 0.583411ZM107.016 158.083H57.0164V161.417H107.016V158.083ZM39.6125 12.2904C38.236 20.0247 35.6337 36.4446 34.7794 53.6861C34.3523 62.3067 34.3603 71.1674 35.1869 79.2695C36.0111 87.3481 37.6603 94.7943 40.5917 100.511L43.5578 98.9895C40.8999 93.8068 39.3092 86.8331 38.503 78.9312C37.6992 71.0527 37.6865 62.372 38.1087 53.851C38.953 36.8092 41.5292 20.5443 42.8942 12.8745L39.6125 12.2904ZM40.5917 100.511C44.8771 108.867 52.1563 115.836 57.7478 122.381C63.4789 129.09 67.5045 135.375 66.6684 142.899L69.9813 143.267C70.9858 134.227 66.053 126.971 60.2822 120.216C54.3719 113.298 47.6057 106.883 43.5578 98.9895L40.5917 100.511ZM66.6684 142.899C66.3034 146.184 64.4351 149.425 62.1558 152.244C59.8977 155.037 57.3755 157.247 55.9317 158.485L58.1011 161.015C59.5739 159.753 62.2893 157.38 64.7478 154.34C67.1853 151.325 69.513 147.482 69.9813 143.267L66.6684 142.899ZM45.7043 5.89254C42.5708 6.62102 40.1789 9.10743 39.6125 12.2904L42.8942 12.8745C43.2242 11.0204 44.6092 9.56935 46.4591 9.13929L45.7043 5.89254ZM124.434 12.2756C123.852 9.10369 121.466 6.62134 118.335 5.89113L117.578 9.13734C119.426 9.56852 120.815 11.0198 121.156 12.8772L124.434 12.2756Z"
      fill="#DDDDDD"
    />
    <path
      d="M80.039 37.4843C80.7874 35.181 84.0459 35.181 84.7943 37.4843L88.3102 48.305C88.6449 49.335 89.6048 50.0324 90.6878 50.0324H102.065C104.487 50.0324 105.494 53.1315 103.535 54.555L94.3302 61.2425C93.454 61.8791 93.0873 63.0076 93.422 64.0376L96.9379 74.8583C97.6863 77.1616 95.0501 79.0769 93.0908 77.6534L83.8861 70.9658C83.0099 70.3292 81.8234 70.3292 80.9472 70.9658L71.7426 77.6534C69.7833 79.0769 67.1471 77.1616 67.8955 74.8583L71.4114 64.0376C71.746 63.0076 71.3794 61.8791 70.5032 61.2425L61.2986 54.555C59.3393 53.1315 60.3462 50.0324 62.768 50.0324H74.1456C75.2286 50.0324 76.1885 49.335 76.5232 48.305L80.039 37.4843Z"
      fill="#F0F0F0"
    />
    <path
      d="M125.333 24.9086C128.667 19.0745 142.417 10.7415 151.167 23.6591C161.13 38.3685 151.167 68.2427 127.833 76.1593"
      stroke="#DDDDDD"
      stroke-width="3.33333"
    />
    <path
      d="M39.1791 24.9086C35.8457 19.0745 22.0957 10.7415 13.3457 23.6591C3.38208 38.3685 13.3457 68.2427 36.6791 76.1593"
      stroke="#DDDDDD"
      stroke-width="3.33333"
    />
    <path
      d="M328.667 161.611C314.45 168.156 302 178.499 302 178.499L328.667 178.5V161.611Z"
      fill="#F0F0F0"
    />
    <path
      d="M372 178.499C372 178.499 367 163.365 357.833 158.499C349.961 154.32 339.27 156.838 329.35 161.3C329.122 161.403 328.894 161.506 328.667 161.611V178.5L372 178.499Z"
      fill="#FAFAFA"
    />
    <path
      d="M369.533 176.69C369.553 176.738 369.572 176.786 369.591 176.833L330.333 176.833V162.686C335.114 160.558 339.997 158.933 344.584 158.311C349.266 157.675 353.523 158.099 357.052 159.971C361.184 162.165 364.53 166.794 366.891 171.122C368.053 173.251 368.938 175.237 369.533 176.69ZM310.954 173.877C315.25 170.887 320.906 167.277 327 164.255V176.833L306.856 176.833C308.007 175.972 309.389 174.967 310.954 173.877Z"
      stroke="#DDDDDD"
      stroke-width="3.33333"
    />
    <path
      d="M2 176.833H402"
      stroke="#DDDDDD"
      stroke-width="3.33333"
      stroke-linecap="round"
    />
    <circle
      cx="312"
      cy="108.499"
      r="18.3333"
      fill="white"
      stroke="#DDDDDD"
      stroke-width="3.33333"
    />
    <path
      d="M272 9.60022L282.289 9.67879L311.582 90.6116L302.126 93.8664L272 9.60022Z"
      fill="#DDDDDD"
    />
    <path
      d="M307.833 8.5C307.833 8.5 311.338 8.70686 313.25 9.34262C315.259 10.0108 317.833 12.289 317.833 12.289V91H307.833V8.5Z"
      fill="#DDDDDD"
    />
  </svg>
</template>

<style lang="scss" scoped>
svg {
  width: 100%;
  height: 100%;
}
</style>
